import { useState } from "react";
import { Form, Formik } from "formik";
import { array, object } from "yup";
import Card from "../UI/Card";
import Tooltip from "../UI/Tooltip";
import Button from "../UI/Button";
import ButtonCard from "../UI/ButtonCard";
import ModalDialog from "../UI/ModalDialog";
import Text from "../UI/Text";
import Title from "../UI/Title";
import FormikSubmitButton from "../UI/FormikSubmitButton";
// @ts-expect-error pure js
import IconAndText from "../UI/IconAndText";
import FileInput from "../UI/FileInput";
// @ts-expect-error pure js
import Img from "../UI/Img";
// @ts-expect-error pure js
import { DocType } from "../../utils/constants/documents";
// @ts-expect-error pure js
import useDocumentBlob from "../../hooks/use-document-blob.js";
// @ts-expect-error pure js
import useLoader from "../../hooks/use-loader.js";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils";
import styles from "./Logo.module.css";
import { IconInfoCircle, IconWriting } from "@tabler/icons-react";

interface LogoProps {
  customization?: { logo_file?: { id?: number } | null } | null;
  onSave: (data: { logo_file?: unknown }) => Promise<unknown>;
  onReset: (fieldsToReset: string[]) => Promise<unknown>;
  isProfile?: boolean;
}

export default function Logo({
  customization,
  onSave,
  onReset,
  isProfile,
}: LogoProps) {
  const [modalOpen, setModalOpen] = useState(false);

  const { blob: logoBlob } = useDocumentBlob({
    documentId: customization?.logo_file?.id,
    doctype: DocType.LOGO,
  });

  async function saveLogoHandler({ files }: { files: unknown[] }) {
    try {
      await onSave({ logo_file: files[0] });
      setModalOpen(false);
    } catch (error) {
      console.error(error);
    }
  }

  const [resetting, resetHandler] = useLoader(async () => {
    try {
      await onReset(["logo_file"]);
    } catch (e) {
      handleAPIError(e);
    }
  });

  const deleteButtonText = isProfile
    ? "Utiliser le logo du compte"
    : "Utiliser le logo Qalimo";

  return (
    <>
      <ModalDialog
        open={modalOpen}
        onOpenChange={setModalOpen}
        header="Ajouter un logo"
      >
        <Formik
          initialValues={{ files: [] }}
          onSubmit={saveLogoHandler}
          validationSchema={object({
            files: array().of(object()).length(1, "Un logo est requis"),
          })}
        >
          <Form>
            <FileInput
              documentId={customization?.logo_file?.id}
              doctype={DocType.LOGO}
              label="Sélectionnez votre logo"
              format={"Format PNG, JPG, JPEG"}
              accept=".png,.jpg,.jpeg"
            />
            <FormikSubmitButton>Enregistrer</FormikSubmitButton>
          </Form>
        </Formik>
      </ModalDialog>
      <Card className={styles.card}>
        <Title variant="hecto" weight="medium">
          Logo personnalisé sur les documents{" "}
          <Tooltip
            content={
              <Text variant="deci">
                Le logo visible ici apparaîtra sur tous les documents générés
                pour ce profil bailleur.
              </Text>
            }
          >
            <IconInfoCircle size={16} />
          </Tooltip>
        </Title>
        <ButtonCard
          onClick={() => setModalOpen(true)}
          className={styles.buttonCard}
          requiresWrite
        >
          <IconAndText
            icon={<IconWriting />}
            text={
              <>
                <Text weight="bold">Ajouter un logo</Text>
                <Text variant="deci" color="muted">
                  PNG, JPG, JPEG
                </Text>
              </>
            }
          />
        </ButtonCard>
        <Card className={styles.preview}>
          {logoBlob ? (
            <Img blob={logoBlob} alt="logo" className={styles.previewImg} />
          ) : (
            <img src={"/Qalimo-logo.png"} alt="logo" />
          )}
        </Card>
        <div className={styles.actions}>
          <Button
            type={"button"}
            variant="tertiary"
            onClick={resetHandler}
            isLoading={resetting}
            requiresWrite
          >
            {deleteButtonText}
          </Button>
        </div>
      </Card>
    </>
  );
}
